module.exports = __webpack_public_path__ + "static/media/SCR053.4392d179.mp3";